import { ContentToChildren } from "utilities/validatoros/types";
import {
  Infer,
  any,
  array,
  enums,
  nullable,
  object,
  string,
} from "superstruct";
import { LiveInspectorData } from "types/types";
import { ModCfMediaQueriesTextAlign, TextAlign } from "types/generic/types";
import { ModCfText as ModCfTextPartial } from "types/cf-utils/types";

export const ModTextStyle = object({
  contentful_id: string(),
  textTheme: nullable(enums(["light"])),
  textAlign: nullable(ModCfMediaQueriesTextAlign),
});

export const ModCfText = object({
  __typename: enums(["ContentfulTextV2"]),
  id: string(),
  contentful_id: string(),
  titleHeading: nullable(string()),
  text: ModCfTextPartial,
  ctaList: nullable(array(any())), // TODO: ctaList
  textStyle: nullable(array(ModTextStyle)),
});

type CfTextOriginal = Infer<typeof ModCfText>;

export type CfTextProps = ContentToChildren<CfTextOriginal>;

interface TextStyle extends TextAlign {
  textTheme?: "light";
}

export interface TextProps extends TextStyle {
  titleHeading: string;
  text: React.ReactNode;
  ctaList?: React.ReactNode;
  liveInspector: LiveInspectorData;
}
